<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("Material.ObjectName") }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="materials"
        :loading="loading"
        multi-sort
        class="elevation-0 px-6"
        v-resize="resizeHeader"
        :footer-props="footerProps"
      >
        <template v-slot:item.net_weight="{ item }">
          <span>
            {{ item.net_weight }}
            {{ item.material.cost_unit }}
          </span>
        </template>
        <template v-slot:item.gross_weight="{ item }">
          <span>
            {{ item.gross_weight }}
            {{ item.material.cost_unit }}
          </span>
        </template>
        <template v-slot:item.major_ingredient_flg="{ item }">
          <span>
            <v-chip
              small
              label
              dark
              :color="item.major_ingredient_flg ? 'primary' : 'grey'"
            >
              {{
                item.major_ingredient_flg
                  ? $t("Recipes.Fields.main_ingredient")
                  : $t("Recipes.Fields.ingredients")
              }}
            </v-chip>
          </span>
        </template>
      </v-data-table>
      <v-card-actions>
        <span class="caption"> </span>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          class="elevation-1"
          @click="dialog = false"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Recipes from "@/api/recipes";

export default {
  name: "MaterialsSelectsDialog",

  props: {
    value: Boolean,
    formulaId: Number,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("Material.ObjectName"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "material.material_name",
        },
        {
          text: i18n.t("Recipes.Fields.net_weight"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "net_weight",
        },
        {
          text: i18n.t("Recipes.Fields.gross_weight"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "gross_weight",
        },
        {
          text: i18n.t("Recipes.Fields.ingredient_type"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "major_ingredient_flg",
        },
      ];
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    materials: [],
    itemsPerPageOptions: 10,
  }),

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },
    //获取material列表
    getMaterialsFromAPI() {
      Recipes.getSettingInfo(this.formulaId).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.materials = response.data.food_formula.formula_cost_card;
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = this.value;
          this.getMaterialsFromAPI();
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
  },
};
</script>